import Link from '@talkdesk/cobalt-react-link'
import Flex from '@talkdesk/cobalt-react-flex'
import Base from '../../pages/Base'
import RecoveryOTPWithContext from '../../components/RecoveryOTP'
import TOTPWithContext from '../../components/TOTP'
import WebAuthnWithContext from '../../components/WebAuthn'
import { useTranslation } from 'react-i18next'
import { MFA_SELECTOR } from '../../constants/steps'
import { RECOVERY_OTP, TOTP, WEB_AUTHN } from 'mfa'

const getMFAMechanism = ({
  mfa,
  metadata,
  loginTimestamp,
  talkdeskIdAssetsURL,
  ...props
}) =>
  ({
    [RECOVERY_OTP]: <RecoveryOTPWithContext {...props} />,
    [TOTP]: <TOTPWithContext {...props} />,
    [WEB_AUTHN]: (
      <WebAuthnWithContext
        data={mfa.data}
        webAuthnTokenTtl={
          metadata && metadata.webAuthn ? metadata.webAuthn.ttl : null
        }
        loginTimestamp={loginTimestamp}
        talkdeskIdAssetsURL={talkdeskIdAssetsURL}
        {...props}
      />
    ),
  })[mfa.type.toUpperCase()]

const MFA = (props) => {
  const { t } = useTranslation()

  return (
    <Base
      brandingSettings={props.brandingSettings}
      showGoogleFooterLink={props.showGoogleFooterLink}
    >
      {getMFAMechanism(props)}
      <Flex paddingTop={4} alignX='center'>
        <Link
          href='#'
          onClick={(event) => {
            event.preventDefault()
            props.changeStep(MFA_SELECTOR)
          }}
          style={{ lineHeight: 'normal' }}
        >
          {t('mfa.footnoteAction')}
        </Link>
      </Flex>
    </Base>
  )
}

export default MFA
